import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { ISelectValue } from 'constants/globalTypes'
import { useState } from 'react'
import { Button, Flex, H1WithBack, PageFooter, PageWrapper, SquareIcon } from 'styling/GlobalStyles'
import { PlusIcon } from 'assets/icons/PlusIcon'
import { CancelBtn } from 'components/Button/CancelBtn'
import { toast } from 'react-toastify'
import { addFoodStandByProvisioning } from 'features/food/foodSlice'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { dietaryPreferences } from '../foodData'

export const StandByFoodProvisioning = () => {

    const [state, setState] = useState<IStandByFoodProvisioningState>({
        date: null,
        mealTypes: [
            {
                id: new Date().getTime(),
                mealType: null,
                count: 0,
                dietaryPreferenceType: null,
                foodSupplier: null,
            }
        ]
    })
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const handleDate = (date: Date, name: string) => {
        setState({ ...state, [name]: date })
    }

    const handleSelect = (selectedOption: ISelectValue, name: string, id: number) => {
        const updatedMealTypes = state.mealTypes.map((mealType) =>
            mealType.id === id ? { ...mealType, [name]: selectedOption } : mealType
        );
        setState({ ...state, mealTypes: updatedMealTypes });
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        const { value } = e.target;
        const updatedMealTypes = state.mealTypes.map((mealType) =>
            mealType.id === id ? { ...mealType, count: Number(value) } : mealType
        );
        setState({ ...state, mealTypes: updatedMealTypes });
    }

    const parse = (data: any) => {
        return data.data.map((item) => ({ label: item.name, value: item.id }))
    }

    const handleAddMealType = () => {
        const newMealType = {
            id: new Date().getTime(),
            mealType: null,
            count: 0,
            dietaryPreferenceType: null,
            foodSupplier: null,
        };
        setState({ ...state, mealTypes: [...state.mealTypes, newMealType] });
    }

    const handleSubmit = async () => {
        if (!state.date || state.mealTypes.length === 0 || state.mealTypes.some(mt => !mt.mealType?.value || !mt.count || !mt.dietaryPreferenceType?.value || !mt.foodSupplier?.value)) {
            toast.warn('Please fill in all required fields');
            return;
        }
        const resp = await dispatch(addFoodStandByProvisioning(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between center mb='16' >
                <H1WithBack arrow title='Ad Hoc Meal Provisioning' />
            </Flex>
            <CalendarInput width='300px' labelText='Date' name='date' nomarg defaultValue={state.date} onChange={handleDate} required />
            <Flex column gap='1rem' mt='16' >
                {state.mealTypes.map((mealType, index) => <Flex gap='1rem' key={index} >
                    <HonestSelectAsyncInput
                        name='mealType'
                        labelText='Meal Types'
                        onChange={(option) => handleSelect(option, 'mealType', mealType.id)}
                        placeholder='Select Meal Type'
                        defaultValue={mealType?.mealType?.label}
                        link='food/management/meal/type'
                        parserFunction={parse}
                        nomarg
                        required
                    />
                    <Input labelText='Count' name='name' value={mealType.count} onChange={e => handleChange(e, mealType.id)} placeholder='3' required />
                    <HonestSelectInput options={dietaryPreferences} labelText='Dietary Preference' name='dietaryPreferenceType' onChange={(v: ISelectValue, n) => handleSelect(v, n, mealType.id)} required />
                    <HonestSelectAsyncInput
                        name='foodSupplier'
                        labelText='Meal Supplier'
                        onChange={(option) => handleSelect(option, 'foodSupplier', mealType.id)}
                        placeholder='Main Kitchen..'
                        link='food/management/meal/supplier'
                        parserFunction={parse}
                        defaultValue={mealType?.foodSupplier?.label}
                        nomarg
                        required
                    />
                </Flex>)}
            </Flex>
            <Flex width='100%' justend mt='16'> <SquareIcon onClick={handleAddMealType} >{PlusIcon}</SquareIcon> </Flex>
        </PageWrapper>
        <PageFooter>
            <Flex gap='1rem'>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </Flex>
        </PageFooter>
    </>
}

export interface IStandByFoodProvisioningState {
    date: Date
    mealTypes:
    {
        id: number
        mealType: ISelectValue
        count: number
        dietaryPreferenceType: ISelectValue
        foodSupplier: ISelectValue
    }[]
}